/**
 * Describes the interface for modal dialogs. This object must get fulfilled
 * as soon as the view is part of the DOM. It must also call destroy() on itself
 * once the dialog is no longer part of the DOM.
 * @interface
 * @extends {Foundation.View.Interface}
 * @param {jQuerySelector?} viewSelector
 */
Foundation.View.Interface.ModalDialog = function (viewSelector) {};

/**
 * A promise to be fulfilled when the dialog is closed.
 * @return {!Foundation.Promise}
 */
Foundation.View.Interface.ModalDialog.prototype.closed = function () {};

/**
 * @param {jQuerySelector?} viewSelector
 */
Foundation.View.Interface.ModalDialog.prototype.setView = function (viewSelector) {};

/**
 * Refresh the layout. Use this when the dialog size changes or position on the
 * document needs to change.
 */
Foundation.View.Interface.ModalDialog.prototype.redraw = function () {};

/**
 * Close the modal dialog.
 */
Foundation.View.Interface.ModalDialog.prototype.close = function () {};

/* eslint no-unused-vars: "off" */
